<template>
  <div class="settings">
    <popover no-padding v-model="showPopover" type="dropdown" theme="light" v-if="screen.breakPoint.tabPort">
      <template v-slot:activator>
        <div class="d-flex align-center justify-center cursor-pointer">
          <div class="settings__icon">
            <div class="icon--medium text-color-purple icon-box pa-05"></div>
            <div class="settings__chip" v-if="statusNotificationMessage" :class="`settings__chip--${statusNotificationMessage.type}`"></div>
          </div>
          <div class="text--medium">{{ profile.marketingName }}</div>
          <div class="settings__arrow icon-show animate-smooth text-color-space"
               :class="{ 'rotate-180': showPopover }"></div>
        </div>
      </template>

      <div class="pt-2">
        <div class="set-indent pb-05 text--xs-small text--uppercase text-color-space">{{ $t('components.SettingsControl.merchant') }}</div>

        <list-item one-column>
          <template #firstColumn>
            <list-item-title>{{ profile.marketingName }}</list-item-title>
          </template>
        </list-item>
      </div>

      <div class="set-indent pt-2" v-if="statusNotificationMessage">
        <div class="settings__notification" :class="`settings__notification--${statusNotificationMessage.type}`">
          <div class="px-1 py-05 text--center text--small">
            {{ statusNotificationMessage.text }}
          </div>
        </div>
      </div>

      <div class="set-indent py-2">
        <a href="#" @click.prevent="handleShowProfileStatus()" class="settings__item d-block py-1">
          <i class="icon-mode mr-05"></i> {{$t('components.SettingsControl.profileStatus')}}
        </a>
        <a href="#" @click.prevent="handleShowProfile()" class="settings__item d-block py-1">
          <i class="icon-settings mr-05"></i> {{$t('components.SettingsControl.manageProfile')}}
        </a>
        <a href="#" @click.prevent="handleResetPass()" class="settings__item d-block py-1">
          <i class="icon-attention mr-1"></i>{{$t('components.Menu.resetPass')}}
        </a>
        <a href="#" @click.prevent="handleDeleteAccount()" v-if="isIos" class="settings__item d-block py-1 text-color-error">
          <i class="icon-trash mr-05"></i> {{$t('views.Profile.deleteAccount')}}
        </a>
      </div>

      <div class="divider"></div>

      <div class="set-indent py-2">
        <a href="#" @click.prevent="handleShowStores()" class="settings__item d-block py-1" v-if="ShowStores">
          <i class="icon-shop-large mr-05"></i> {{$t('components.ManagersList.manageStores')}}
        </a>

        <a href="#" @click.prevent="handleShowUsers()" class="settings__item d-block py-1" v-if="ShowManagersList">
          <i class="icon-users mr-05"></i> {{$t('components.SettingsControl.users')}}
        </a>

        <a href="#" @click.prevent="handleShowTerminals()" class="settings__item d-block py-1" v-if="ShowTerminals">
          <i class="icon-payment-terminal mr-05" :style="{ fontSize: '1.6rem' }"></i> {{$t('components.Menu.manageTerminals')}}
        </a>
      </div>

      <div class="divider"></div>

      <div class="set-indent">
        <a href="#" @click.prevent="logout" class="settings__item d-block py-2">
          <i class="icon-logout mr-05"></i> {{$t('components.ProfileStatus.logout')}}
        </a>
      </div>
    </popover>

    <v-modal v-model="showPopover" full fit-content animation="slide-up" position="bottom" no-padding handle-click-bg v-else>
      <template #activator="{ on }">
        <div class="d-flex align-center justify-center cursor-pointer" @click="on">
          <div class="settings__icon">
            <div class="icon--medium text-color-purple icon-box pa-05"></div>
            <div class="settings__chip" v-if="statusNotificationMessage" :class="`settings__chip--${statusNotificationMessage.type}`"></div>
          </div>
          <div class="text--medium">{{ profile.marketingName }}</div>
          <div class="settings__arrow icon-show animate-smooth text-color-space"
               :class="{ 'rotate-180': showPopover }"></div>
        </div>
      </template>

      <template #header>
        {{ $t('components.SettingsControl.merchant') }}
      </template>

      <div class="pt-2">
        <div class="set-indent pb-05 text--xs-small text--uppercase text-color-space">{{ $t('components.SettingsControl.merchant') }}</div>

        <list-item one-column>
          <template #firstColumn>
            <list-item-title>{{ profile.marketingName }}</list-item-title>
          </template>
        </list-item>
      </div>

      <div class="set-indent pt-2" v-if="statusNotificationMessage">
        <div class="settings__notification" :class="`settings__notification--${statusNotificationMessage.type}`">
          <div class="px-1 py-05 text--center text--small">
            {{ statusNotificationMessage.text }}
          </div>
        </div>
      </div>

      <div class="set-indent py-2">
        <a href="#" @click.prevent="handleShowProfileStatus()" class="settings__item d-block py-1">
          <i class="icon-mode mr-05"></i> {{$t('components.SettingsControl.profileStatus')}}
        </a>
        <a href="#" @click.prevent="handleShowProfile()" class="settings__item d-block py-1">
          <i class="icon-settings mr-05"></i> {{$t('components.SettingsControl.manageProfile')}}
        </a>
        <a href="#" @click.prevent="handleResetPass()" class="settings__item d-block py-1">
          <i class="icon-attention mr-05"></i> {{$t('components.Menu.resetPass')}}
        </a>
        <a href="#" @click.prevent="handleDeleteAccount()" v-if="isIos" class="settings__item d-block py-1 text-color-error">
          <i class="icon-trash mr-05"></i> {{$t('views.Profile.deleteAccount')}}
        </a>
      </div>

      <div class="divider"></div>

      <div class="set-indent py-2">
        <a href="#" @click.prevent="handleShowStores()" class="settings__item d-block py-1" v-if="ShowStores">
          <i class="icon-shop-large mr-05"></i> {{$t('components.ManagersList.manageStores')}}
        </a>

        <a href="#" @click.prevent="handleShowUsers()" class="settings__item d-block py-1" v-if="ShowManagersList">
          <i class="icon-users mr-05"></i> {{$t('components.SettingsControl.users')}}
        </a>

        <a href="#" @click.prevent="handleShowTerminals()" class="settings__item d-block py-1" v-if="ShowTerminals">
          <i class="icon-payment-terminal mr-05" :style="{ fontSize: '1.6rem' }"></i> {{$t('components.Menu.manageTerminals')}}
        </a>
      </div>

      <div class="divider"></div>

      <div class="set-indent py-2 pb-1">
        <a href="#" @click.prevent="logout" class="settings__item d-block py-1">
          <i class="icon-logout mr-05"></i> {{$t('components.ProfileStatus.logout')}}
        </a>
      </div>

      <div v-if="isNative && appInfo" class="set-indent py-2 pb-1 d-flex justify-center text--center text--small text-color-space">
        version {{ appInfo.version }} build #{{ appInfo.build }}
      </div>
    </v-modal>

    <profile v-model="showProfile" :profileProp="profile" :default-section="defaultProfileSection"></profile>
    <managers-list v-model="showManagers" v-if="ShowManagersList"></managers-list>
    <profile-status v-model="showProfileStatus" :profile="profile"></profile-status>
    <terminals-list v-model="showTerminals" v-if="ShowTerminals"></terminals-list>
    <reset-password v-model="showResetPass"></reset-password>
    <delete-account-simple v-model="showDeleteAccount"></delete-account-simple>
<!--    <delete-account v-model="showDeleteAccount"></delete-account>-->
<!--    <button class="settings-control button-icon" @click="clickAction()">-->
<!--      <i class="icon-settings icon--medium text-color-purple"></i>-->

<!--    </button>-->
  </div>
</template>

<script>
import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'

import Popover from '@/ui/modals/Popover'
import ListItem from '@/ui/slots/List/ListItem'
import ListItemTitle from '@/ui/slots/List/ListItemTitle'
import vModal from '@/ui/modals/vModal'

import Profile from '@/components/Profile'
import ProfileStatus from '@/components/ProfileStatus'
import ManagersList from '@/components/ManagersList'
import TerminalsList from '@/components/TerminalsList'
import ResetPassword from '@/components/Profile/ResetPassword'
// import DeleteAccount from '@/components/Profile/DeleteAccount'
import DeleteAccountSimple from '@/components/Profile/DeleteAccountSimple'

import profile from '@/mixins/profile'
import confirmAction from '@/mixins/confirmAction'
import statusNotificationMessage from '@/mixins/statusNotificationMessage'
import screen from '@/mixins/screen'
import { ShowManagersList, ShowStores, ShowTerminals } from '@/mixins/displayRules'
import { removePinToken } from '@/mixins/pinToken'
import { notifyGraphqlError } from '@/mixins/handleGraphqlError'

import { onLogout } from '@/vue-apollo'
// import { DeleteMerchantGQL } from '@/graphql/mutations'

export default {
  mixins: [profile, confirmAction, statusNotificationMessage, screen, ShowTerminals, ShowManagersList, ShowStores, removePinToken, notifyGraphqlError],

  data () {
    return {
      showPopover: false,
      showProfile: false,
      showProfileStatus: false,
      showManagers: false,
      showTerminals: false,
      showResetPass: false,
      showDeleteAccount: false,
      isNative: Capacitor.isNativePlatform(),
      appInfo: null,

      defaultProfileSection: null
    }
  },

  components: {
    ResetPassword,
    Popover,
    Profile,
    ListItem,
    ListItemTitle,
    ProfileStatus,
    ManagersList,
    TerminalsList,
    DeleteAccountSimple,
    vModal
    // ActionLink
  },

  computed: {
    isIos () {
      return Capacitor.getPlatform() === 'ios'
    }
  },

  methods: {
    clickAction () {
      this.$emit('click')
    },

    settingsClick () {
      this.showProfile = true
    },

    handleShowProfileStatus () {
      this.showProfileStatus = true
      // this.showPopover = false
    },

    handleShowUsers () {
      this.showManagers = true
      // this.showPopover = false
    },

    handleShowProfile () {
      this.showProfile = true
      // this.showPopover = false
    },

    handleShowTerminals () {
      this.showTerminals = true
      // this.showPopover = false
    },

    handleResetPass () {
      this.showResetPass = true
    },

    handleDeleteAccount () {
      this.showDeleteAccount = true
      // this.confirmAction(this.$i18n.t('views.Profile.areYouSureWant'), async () => {
      //   try {
      //     await this.$apollo.mutate({
      //       mutation: DeleteMerchantGQL,
      //       variables: {
      //         params: {
      //           code: null
      //         }
      //       }
      //     })
      //     this.showDeleteAccount = true
      //   } catch (e) {
      //     this.notifyGraphqlError(e)
      //   }
      // })
    },

    handleShowStores () {
      this.defaultProfileSection = 'shopSection'
      this.showProfile = true
      setTimeout(() => { this.defaultProfileSection = null }, 1500)
    },

    async logoutExec () {
      await this.removePinToken()
      await onLogout(this.$apollo.getClient())
      await this.$router.push({
        name: 'auth_login'
      })
    },

    logout () {
      this.confirmAction(this.$i18n.t('components.ProfileStatus.areYouSureToLogout'), () => { this.logoutExec() })
    }
  },

  async beforeMount () {
    if (this.isNative) {
      this.appInfo = await App.getInfo()
    }
  }
}
</script>

<style lang="scss">
.settings {
  &__arrow {
    font-size: 1rem;
    margin-left: 1rem;
  }

  &__icon {
    position: relative;
  }

  &__chip {
    position: absolute;
    width: 1rem;
    height: 1rem;
    right: 0.2rem;
    top: 0.3rem;
    border-radius: 50%;

    background-color: $color-yellow;

    &--error {
      background-color: $color-red;
    }

    &--success {
      background-color: $color-green;
    }
  }

  &__notification {
    border-radius: $border-radius;
    border: 2px solid lighten($color-yellow, 15);
    background-color: lighten($color-yellow, 35);

    &--error {
      border: 2px solid $color-red-light;
      background-color: lighten($color-red-light, 13);
    }

    &--success {
      border: 2px solid $color-green-lighten;
      background-color: lighten($color-green-lighten, 12);
    }
  }
}

.settings-control {
  &:hover {
    cursor: pointer;
  }
}
</style>
